import { render, staticRenderFns } from "./DTooltip.vue?vue&type=template&id=7536bae8&scoped=true&"
import script from "./DTooltip.vue?vue&type=script&lang=js&"
export * from "./DTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DTooltip.vue?vue&type=style&index=0&id=7536bae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536bae8",
  null
  
)

export default component.exports